module.exports = {
  dsn: 'https://16a8291a236a41fe8f36d3fd90c09774@sentry.io/173759',
  ignoreErrors: [
    // Axios response status codes that throw errors
    'Request failed with status code 310', // private community
    'Request failed with status code 400', // custom not found?
    'Request failed with status code 401', // unauthorised, page not available to visitors
    'Request failed with status code 404', // not found, could be a private community
    'Request failed with status code 410', // post deleted
    'Request failed with status code 500', // server error
    'Request failed with status code 504', // server timeout
    'Request aborted', // request interrupted for some reason
    'Network Error', // problem with user's connection

    'Unsaved changes. Route change blocked.', // Stops navigation if the user has unsaved changes and they confirm the prompt
  ],
  whitelistUrls: [
    /assets.hu-production.be/i,
  ],
};
// ignoreErrors: [

//   'Non-Error promise rejection captured', // TECH-52

//   // Login error messages
//   'Email/password combination isn\'t right or email already in use',
//   'La combinación de correo electrónico / contraseña no es correcta o el correo electrónico ya está en uso', // es
//   'A combinação de e-mail / senha não está correta ou o e-mail já está em uso', // pt
//   'It looks like you left your email address out. Add it and try again!',
//   'This email address has already been registered. Already a member? Try \'Log in\' below.',
//   'Your account has been locked. Please reset your password',
//   'Sua conta foi bloqueda. Por favor modifique sua senha para continuar', // pt
// ],
// denyUrls: [

// ]

